import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { FOOTER_HEIGHT } from '@/lib/constants'

type Props = {
  onDone: () => void
  children: ReactNode
}

/** 初めて開いた作品で読み方を選んでもらうカード。選んだ内容はその場で反映する */
export const LayoutPrompt = ({ onDone, children }: Props) => (
  <div
    role="dialog"
    aria-label="この作品の読み方"
    className="absolute left-1/2 z-40 grid w-[min(92vw,24rem)] -translate-x-1/2 gap-2.5 rounded-lg border bg-popover p-3 text-popover-foreground shadow-lg"
    style={{ bottom: `calc(${FOOTER_HEIGHT} + 64px)` }}
    onClick={(e) => e.stopPropagation()}
  >
    <p className="text-sm font-medium">この作品の読み方</p>
    {children}
    <Button size="sm" className="w-full" onClick={onDone}>
      この設定で読む
    </Button>
    <p className="text-[10px] text-muted-foreground">
      この作品では次回もこの設定で開きます（設定からいつでも変えられます）
    </p>
  </div>
)
